// extracted by mini-css-extract-plugin
module.exports = {"radio":"radio_radio__1iICN","disabled":"radio_disabled__9Qnup"};